"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function AgentsWithCustomersIcon() {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", xmlBase: "/", width: "34", height: "34", viewBox: "0 0 34 34", id: "agents-with-customers-icon" },
        React.createElement("defs", null,
            React.createElement("path", { id: "agents-with-customer-a", d: "M0 0h14v13H0z" }),
            React.createElement("path", { id: "agents-with-customer-c", d: "M0 31h30V.999H0z" })),
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("path", { fill: "#767F8C", d: "M9 32.001h4v-4H9zM2.27 16v8.98l2.722 3.012 4.008.01V16zM28 16.001h-7v12l4-.01 3-3.011" }),
            React.createElement("path", { fill: "#979AA0", d: "M2 16v8.98l3 3.022V16z" }),
            React.createElement("path", { fill: "#8F96A0", d: "M28 25.001l-3 3v-12h3z" }),
            React.createElement("g", { transform: "translate(2 1.001)" },
                React.createElement("path", { fill: "#B2B9C2", d: "M14 1L12.604.999C5.672.999 0 6.671 0 13.604V15h3v-1.406a9.595 9.595 0 0 1 9.595-9.595L14 3.992V1z" }),
                React.createElement("g", { transform: "translate(16 1)" },
                    React.createElement("mask", { id: "agents-with-customer-b", fill: "#fff" },
                        React.createElement("use", { xlinkHref: "#agents-with-customer-a" })),
                    React.createElement("path", { fill: "#96BC33", d: "M13.996 0L0 .004V13l3.083-3H14z", mask: "url(#agents-with-customer-b)" })),
                React.createElement("mask", { id: "agents-with-customer-d", fill: "#fff" },
                    React.createElement("use", { xlinkHref: "#agents-with-customer-c" })),
                React.createElement("path", { fill: "#FFF", d: "M18 7h2V5h-2zM22 7h2V5h-2zM26 7h2V5h-2z", mask: "url(#agents-with-customer-d)" }),
                React.createElement("path", { fill: "#B2B9C2", d: "M23 15h3v-2h-3z", mask: "url(#agents-with-customer-d)" })))));
}
exports.AgentsWithCustomersIcon = AgentsWithCustomersIcon;
